var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUnits(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.8281 8L57.2957 15.0628V84.0125L21.8281 91.0753V8ZM25.2681 12.1926V86.8828L53.8557 81.19V17.8853L25.2681 12.1926Z",
    fill: "#2D2943"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.875 68.5762H85.0026L80.5372 83.1962H69.3404L64.875 68.5762ZM69.5226 72.0162L71.8866 79.7562H77.991L80.355 72.0162H69.5226Z",
    fill: "#2D2943"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 16.6797H25.2676V85.9542H7V16.6797ZM10.44 20.1197V82.5142H21.8276V20.1197H10.44Z",
    fill: "#2D2943"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.0002 84.0562H55.1602V80.6162H93.0002V84.0562Z",
    fill: "#2D2943"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M74.9703 66.1047C74.9703 66.1047 70.895 65.668 68.4697 62.8722C66.0445 60.0765 66.1876 55.9804 66.1876 55.9804C66.1876 55.9804 70.2629 56.417 72.6882 59.2128C75.1135 62.0085 74.9703 66.1047 74.9703 66.1047Z",
    fill: "#2D2943"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0571 66.1047C75.0571 66.1047 79.1323 65.668 81.5576 62.8722C83.9829 60.0765 83.8397 55.9804 83.8397 55.9804C83.8397 55.9804 79.7644 56.417 77.3391 59.2128C74.9139 62.0085 75.0571 66.1047 75.0571 66.1047Z",
    fill: "#2D2943"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M75.3294 57.0682C75.3294 57.0682 71.9962 56.7111 70.0125 54.4244C68.0288 52.1376 68.1459 48.7873 68.1459 48.7873C68.1459 48.7873 71.4792 49.1445 73.4629 51.4312C75.4465 53.7179 75.3294 57.0682 75.3294 57.0682Z",
    fill: "#2D2943"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0026 57.0682C75.0026 57.0682 78.3359 56.7111 80.3196 54.4244C82.3032 52.1376 82.1861 48.7873 82.1861 48.7873C82.1861 48.7873 78.8529 49.1445 76.8692 51.4312C74.8855 53.7179 75.0026 57.0682 75.0026 57.0682Z",
    fill: "#2D2943"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1781 50.2493C75.1781 50.2493 76.6608 48.6561 76.6608 46.6907C76.6608 44.7253 75.1781 43.1321 75.1781 43.1321C75.1781 43.1321 73.6953 44.7253 73.6953 46.6907C73.6953 48.6561 75.1781 50.2493 75.1781 50.2493Z",
    fill: "#2D2943"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6594 47.5062C33.6594 48.6936 32.6968 49.6562 31.5094 49.6562C30.322 49.6562 29.3594 48.6936 29.3594 47.5062C29.3594 46.3188 30.322 45.3562 31.5094 45.3562C32.6968 45.3562 33.6594 46.3188 33.6594 47.5062Z",
    fill: "#2D2943"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.2208 57.3962L30.2208 51.3762L32.8008 51.3762L32.8008 57.3962L30.2208 57.3962Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnits);
export default __webpack_public_path__ + "static/media/units.3dba1fe6.svg";
export { ForwardRef as ReactComponent };